/* Pack de 3 toiles déco 24 x 30 cm : choix des 3 designs (snippets/uk-pack-trio.liquid).
   - Un toucher sur un design le place dans la prochaine case libre ; le même design peut être choisi deux fois, mais seulement par un geste volontaire.
   - Toucher une toile du trio la sélectionne : le design touché ensuite la remplace. La croix la retire.
   - Le bouton d'ajout au panier du thème reste désactivé tant que les 3 toiles ne sont pas choisies ; les choix partent dans le formulaire
     en propriétés de la ligne : « Toile 1/2/3 » (nom + référence) et « _Toile N fiche » (adresse et identifiant de la fiche). */
(function () {
  var sec = document.getElementById('uk-trio');
  if (!sec || sec.dataset.pret) return;
  sec.dataset.pret = '1';
  var N = 3, LIMITE = 30;
  var slots = [null, null, null], actif = null, filtre = '', texte = '', tout = false;
  var prix = sec.dataset.prix || '';
  var cartes = Array.prototype.slice.call(sec.querySelectorAll('[data-carte]'));
  var items = cartes.map(function (c) { return c.closest('[data-item]'); });
  var slotEls = Array.prototype.slice.call(sec.querySelectorAll('[data-slot]'));
  var etat = sec.querySelector('[data-etat]'), aide = sec.querySelector('[data-aide]'), vide = sec.querySelector('[data-vide]'), plus = sec.querySelector('[data-plus]');
  var barre = document.querySelector('[data-barre]'), barreBtn = barre && barre.querySelector('[data-barre-btn]'), mini = barre ? barre.querySelectorAll('[data-mini] span') : [];
  var portee = sec.closest('.product') || document;
  var form = portee.querySelector('form[action*="/cart/add"]') || document.querySelector('form[id^="product-form-' + sec.dataset.produit + '"]');
  var btn = form ? form.querySelector('button[type="submit"]') : null;
  var labelOrigine = btn ? btn.innerHTML : '';

  function norm(s) { return (s || '').toString().toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, ''); }
  function nb() { return slots.filter(Boolean).length; }
  function info(c) { var im = c.querySelector('img'); return { id: c.dataset.id, handle: c.dataset.handle, nom: c.dataset.nom, ref: c.dataset.ref, img: im ? (im.currentSrc || im.src) : '' }; }
  function dire(msg) { if (!aide) return; aide.textContent = msg || ''; aide.hidden = !msg; }

  function choisir(c) {
    var cible = actif !== null ? actif : slots.indexOf(null);
    if (cible < 0) { dire('Votre trio est complet. Touchez une toile de votre trio pour la remplacer, ou retirez-la avec la croix.'); return; }
    slots[cible] = info(c); actif = null; dire('');
    maj();
    var s = slotEls[cible]; if (s) { s.classList.remove('is-nouveau'); void s.offsetWidth; s.classList.add('is-nouveau'); }
  }
  function toucherSlot(i) {
    if (!slots[i]) { actif = i; dire('Choisissez le design de la toile ' + (i + 1) + ' ci-dessous.'); }
    else if (actif === i) { actif = null; dire(''); }
    else { actif = i; dire('Touchez le design qui remplacera la toile ' + (i + 1) + '.'); }
    maj();
  }
  function retirer(i) { slots[i] = null; if (actif === i) actif = null; dire(''); maj(); }

  function champs() {
    if (!form) return;
    Array.prototype.slice.call(form.querySelectorAll('[data-trio-champ]')).forEach(function (e) { e.remove(); });
    slots.forEach(function (s, i) {
      if (!s) return;
      [['Toile ' + (i + 1), s.nom + (s.ref ? ' (' + s.ref + ')' : '')], ['_Toile ' + (i + 1) + ' fiche', s.handle + ' | ' + s.id]].forEach(function (kv) {
        var e = document.createElement('input'); e.type = 'hidden'; e.name = 'properties[' + kv[0] + ']'; e.value = kv[1]; e.setAttribute('data-trio-champ', ''); form.appendChild(e);
      });
    });
  }
  function bouton() {
    var n = nb(), ok = n === N;
    var reste = N - n, txt = ok ? 'Ajouter mon trio — ' + prix : (n === 0 ? 'Choisissez vos 3 toiles pour continuer' : 'Choisissez encore ' + reste + ' toile' + (reste > 1 ? 's' : ''));
    var court = ok ? 'Ajouter mon trio — ' + prix : (n === 0 ? 'Choisissez 3 toiles' : 'Encore ' + reste + ' toile' + (reste > 1 ? 's' : '') + ' à choisir');
    if (btn) { btn.disabled = !ok; btn.setAttribute('aria-disabled', ok ? 'false' : 'true'); btn.textContent = txt; btn.classList.toggle('uk-trio-btn-attente', !ok); }
    if (barreBtn) { barreBtn.textContent = court; barreBtn.classList.toggle('is-pret', ok); }
  }
  function maj() {
    var n = nb();
    if (etat) etat.textContent = n === N ? 'Votre trio est prêt ✓' : (n === 0 ? 'Choisissez 3 toiles' : n + ' / 3 · encore ' + (N - n) + ' à choisir');
    sec.classList.toggle('is-complet', n === N);
    slotEls.forEach(function (el, i) {
      var s = slots[i], img = el.querySelector('[data-slot-img]'), nom = el.querySelector('[data-slot-nom]'), x = el.querySelector('[data-retirer]'), b = el.querySelector('[data-slot-btn]');
      el.classList.toggle('is-vide', !s); el.classList.toggle('is-actif', actif === i);
      img.innerHTML = s ? '<img src="' + s.img + '" alt="">' : '<span class="uk-trio__slot-chiffre" aria-hidden="true">' + (i + 1) + '</span>';
      nom.textContent = s ? s.nom : 'Toile ' + (i + 1); x.hidden = !s;
      b.setAttribute('aria-label', 'Toile ' + (i + 1) + ' : ' + (s ? s.nom + ' (toucher pour remplacer)' : 'à choisir'));
    });
    cartes.forEach(function (c) {
      var k = slots.filter(function (s) { return s && s.id === c.dataset.id; }).length, coche = c.querySelector('[data-coche]');
      c.classList.toggle('is-choisi', k > 0); c.setAttribute('aria-pressed', k > 0 ? 'true' : 'false'); coche.textContent = k > 1 ? '×' + k : '';
    });
    for (var j = 0; j < mini.length; j++) { var s = slots[j]; mini[j].style.backgroundImage = s ? 'url("' + s.img + '")' : ''; mini[j].classList.toggle('is-plein', !!s); }
    champs(); bouton();
  }
  function afficher() {
    var t = norm(texte), vus = 0, total = 0;
    cartes.forEach(function (c, i) {
      var ok = (!filtre || c.dataset.style === filtre) && (!t || norm(c.dataset.nom).indexOf(t) > -1);
      if (ok) total++;
      var montre = ok && (tout || filtre || t || vus < LIMITE);
      if (montre) vus++;
      items[i].hidden = !montre;
    });
    vide.hidden = total > 0;
    var restants = total - vus;
    plus.hidden = restants <= 0; plus.textContent = 'Voir les ' + restants + ' autres designs';
  }

  cartes.forEach(function (c) { c.addEventListener('click', function () { choisir(c); }); });
  slotEls.forEach(function (el, i) {
    el.querySelector('[data-slot-btn]').addEventListener('click', function () { toucherSlot(i); });
    el.querySelector('[data-retirer]').addEventListener('click', function (e) { e.stopPropagation(); retirer(i); });
  });
  Array.prototype.slice.call(sec.querySelectorAll('[data-filtre]')).forEach(function (b, _, tous) {
    b.addEventListener('click', function () {
      filtre = b.dataset.filtre; tous.forEach(function (o) { o.classList.toggle('is-actif', o === b); o.setAttribute('aria-pressed', o === b ? 'true' : 'false'); }); afficher();
    });
  });
  var rech = sec.querySelector('[data-recherche]');
  rech.addEventListener('input', function () { texte = rech.value; afficher(); });
  rech.addEventListener('keydown', function (e) { if (e.key === 'Enter') e.preventDefault(); });
  plus.addEventListener('click', function () { tout = true; afficher(); });

  // aucun ajout au panier tant que le trio n'est pas complet (même par la touche Entrée ou un autre bouton)
  document.addEventListener('submit', function (e) {
    if (e.target !== form || nb() === N) return;
    e.preventDefault(); e.stopImmediatePropagation();
    dire('Choisissez vos 3 toiles pour continuer.'); sec.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }, true);

  // barre fixe en bas de l'écran sur téléphone : compteur + bouton, visible dès qu'on arrive au choix des toiles et tant que le vrai bouton n'est pas à l'écran
  function barreMaj() {
    if (!barre) return;
    if (window.innerWidth >= 1000) { barre.hidden = true; return; }
    var r = sec.getBoundingClientRect(), vh = window.innerHeight, b = btn ? btn.getBoundingClientRect() : null;
    var arrive = r.top < vh * 0.85, boutonVu = b && b.bottom > 0 && b.top < vh;
    barre.hidden = !(arrive && !boutonVu);
  }
  if (barreBtn) barreBtn.addEventListener('click', function () {
    if (nb() === N && btn) { btn.scrollIntoView({ behavior: 'smooth', block: 'center' }); if (form.requestSubmit) form.requestSubmit(btn); else btn.click(); }
    else { var cible = slots.indexOf(null); dire(''); sec.scrollIntoView({ behavior: 'smooth', block: 'start' }); if (cible > -1) actif = null; }
  });
  window.addEventListener('scroll', barreMaj, { passive: true }); window.addEventListener('resize', barreMaj);
  document.querySelectorAll('a[href="#uk-trio"]').forEach(function (a) { a.addEventListener('click', function (e) { e.preventDefault(); sec.scrollIntoView({ behavior: 'smooth', block: 'start' }); }); });

  afficher(); maj(); barreMaj();
})();
